import { stringify } from 'query-string';

const customDataProvider = (apiUrl) => ({
    getList: async (resource, params) => {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        // Construct the query parameters
        const query = {
            sort: JSON.stringify([field, order]),
            range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
            filter: JSON.stringify(params.filter),
        };

        // Construct the URL
        const url = `${apiUrl}/${resource}?${stringify(query)}`;

        // Fetch data from the API
        const response = await fetch(url);
        const json = await response.json();

        // Check for status code and handle accordingly
        if (json.status_code !== 0) {
            throw new Error(json.message || 'Error fetching data');
        }

        return {
            data: json.data, // Use 'data' as per your API response
            total: json.total, // Total count of items
        };
    },

    // Implement other methods if needed, e.g., getOne, create, update, delete
    getOne: async (resource, params) => {
        console.log("running");
        const url = `${apiUrl}/${resource}/${params.id}`;
        const response = await fetch(url);
        const json = await response.json();

        if (json.status_code !== 0) {
            throw new Error(json.message || 'Error fetching data');
        }

        return { data: json.data }; // Assuming single item in 'data'
    },

    // Example for creating a holiday
    create: async (resource, params) => {
        const url = `${apiUrl}/${resource}`;
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(params.data),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const json = await response.json();

        if (json.status_code !== 0) {
            throw new Error(json.message || 'Error creating data');
        }

        return { data: json.data }; // Assuming response contains the new id
    },
    delete: async (resource, params) => {
        const url = `${apiUrl}/${resource}/${params.id}`;
        const response = await fetch(url, {
            method: 'DELETE',
        });
        const json = await response.json();

        if (json.status_code !== 0) {
            throw new Error(json.message || 'Error deleting data');
        }
        return { data: json.message };
    },
    update: async (resource, params) => {
        const url = `${apiUrl}/${resource}/${params.id}`;
        const response = await fetch(url, {
            method: 'PUT',
            body: JSON.stringify(params.data),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const json = await response.json();

        if (json.status_code !== 0) {
            throw new Error(json.message || 'Error updating data');
        }

        return { data: json.data }; // Assuming response contains the updated data
    },
});

// Usage example
// const holidayDataProvider = customDataProvider('http://localhost:5000/appointment');

export default customDataProvider;
